if (!customElements.get('card-product-slider')) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options') || '{}');

      this.sliderWrapper = this.querySelector('.swiper-wrapper');

      // data-prefilled 는 snippets/products-feed.liquid 의 인라인 스크립트가 남긴다.
      // 위시리스트(Swym) 버튼이 붙는 시점을 맞추려고 목록을 파싱 중에 미리 받아 채우는데,
      // 이미 채워졌으면 같은 요청을 되풀이할 이유가 없다. 그대로 두면 innerHTML 을
      // 다시 갈아끼워 방금 붙은 버튼까지 날아간다. 사유는 그 스니펫 주석에 있다.
      //
      // 인라인 쪽이 실패하면 이 속성이 없으므로 기존 경로로 되돌아간다.
      this.requiresFetch = this.hasAttribute('data-url') && !this.hasAttribute('data-prefilled');
      this.parent = this.closest('[data-section-id]');

      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        slidesPerView: swiperOptions.slidesPerViewMobile || 'auto',
        resistanceRatio: 0.72,
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: 6,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          }
        }
      };
      if (swiperOptions.navigation) {
        this.sliderOptions.navigation = { ...swiperOptions.navigation };
      }
      if (swiperOptions.autoplay) {
        this.sliderOptions.autoplay = { ...swiperOptions.autoplay };
      }
      if (swiperOptions.loop) {
        this.sliderOptions.loop = swiperOptions.loop;
      }
    }

    connectedCallback() {
      // 배지 패치는 이 클래스 밖의 전역 프로토타입을 건드리므로 슬라이더 지연과 묶지 않는다.
      // 지연 대상만 있는 페이지에서 패치 시점이 스크롤까지 밀리는 것을 막는다.
      this.patchProductCardOnce();

      // 테마 편집기는 섹션을 수시로 다시 그리므로 지연 없이 바로 초기화한다.
      if (window.Shopify && window.Shopify.designMode) {
        this.startSlider();
        return;
      }

      // 화면 근처까지 미루면 초기화가 스크롤 중으로 몰려 개별 작업이 길어진다.
      // 스크롤 응답이 로딩 이득보다 비싸 로딩 때 바로 시작한다.
      this.startSlider();
    }

    startSlider() {
      // 어느 경로로 불려도 한 번만 실행한다. 요소가 다시 붙을 때 슬라이더가
      // 두 벌 생기고 리사이즈 처리기가 쌓이는 것을 막는다.
      if (this.sliderStarted) return;
      this.sliderStarted = true;

      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }
      this.initSlider();
      this.syncHeights();
      window.addEventListener('resize', () => this.syncHeights());
    }

    // 화면에 들어오기 한 화면 앞서 초기화한다. 관측 API 가 없는 브라우저에서는
    // 예전처럼 즉시 초기화해 동작 차이를 만들지 않는다.
    whenNearViewport(run) {
      if (typeof IntersectionObserver !== 'function') {
        run();
        return;
      }

      // 그려지지 않는 요소는 화면에 들어오는 일이 없어 관측이 끝내 발화하지 않는다.
      // 숨은 채로 시작해 자기 코드로 모습을 드러내는 슬라이더가 여기 해당하므로
      // 그런 경우는 미루지 않고 바로 초기화한다.
      //
      // 이 검사는 숨김 규칙이 렌더를 막는 스타일시트로 먼저 도착한다는 데 기대고 있다.
      // 그 스타일시트를 나중에 비차단으로 돌리면 여기서는 아직 숨김이 안 걸려 통과하고,
      // 뒤늦게 숨겨진 요소는 화면에 들어올 수 없어 초기화가 영영 멈춘다.
      // 에러도 로그도 남지 않으니 CSS 로딩 방식을 바꿀 때 이 줄을 함께 볼 것.
      if (!this.getClientRects().length) {
        run();
        return;
      }
      // 내용을 따로 받아오는 슬라이더는 더 멀리서 깨운다. 받아오기가 화면 도달보다
      // 늦으면 상품이 아직 없는 자리가 노출로 집계될 수 있어서다.
      const margin = this.requiresFetch ? '1500px 0px' : '600px 0px';

      this.viewportObserver = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.stopWatching();
        run();
      }, { rootMargin: margin });
      this.viewportObserver.observe(this);
    }

    stopWatching() {
      if (!this.viewportObserver) return;
      this.viewportObserver.disconnect();
      this.viewportObserver = null;
    }

    // 화면에 들어오기 전에 요소가 떨어져 나가면 관측을 놓아준다.
    disconnectedCallback() {
      this.stopWatching();
    }

    syncHeights() {
      const textSlide = this.querySelector('.products-feed__card-text-custom-slide');
      const actionElement = this.querySelector('.product-card__actions');
      if (textSlide && actionElement) {
        const actionHeight = actionElement.offsetHeight;
        textSlide.style.height = `${actionHeight}px`;
      }
    }

    fetchItems() {
      if (!this.parent) throw new Error('Parent is missing');

      fetch(this.getAttribute('data-url'))
        .then(r => r.text())
        .then(text => {
          // 응답을 기다리는 사이에 프리필이 끝났으면 여기서 멈춘다.
          //
          // snippets/products-feed.liquid 의 인라인 스크립트가 같은 목록을 미리 받아
          // 채우고 data-prefilled 를 남긴다. 위시리스트(Swym) 버튼이 붙는 시점을
          // 맞추려는 것이라, 여기서 innerHTML 을 다시 갈아끼우면 방금 붙은 버튼이
          // 날아간다 — 그 코드가 고치려던 증상 그대로다.
          //
          // 확인을 fetchItems 진입 시점이 아니라 이 자리에서 하는 이유가 있다.
          // connectedCallback → startSlider → fetchItems 는 전부 동기 사슬이고,
          // data-prefilled 는 인라인 fetch 의 .then() 에서 붙는다. 마이크로태스크는
          // 동기 사슬이 끝나야 돌므로, 진입 시점에 읽으면 생성자가 읽은 것과 같은
          // 값만 보게 되어 아무 것도 막지 못한다. 응답이 도착한 이 시점이라야
          // 그 사이에 붙은 값을 볼 수 있다.
          //
          // 남는 한계 — 중복 요청 자체는 그대로 나간다. 막는 것은 덮어쓰기뿐이다.
          // 요청까지 없애려면 프리필 Promise 를 공유해야 하는데, 그 구조는 인라인
          // 스크립트가 실패했을 때의 폴백을 복잡하게 만들어 지금은 택하지 않았다.
          if (this.hasAttribute('data-prefilled')) {
            this.initSlider();
            this.syncHeights();
            window.addEventListener('resize', () => this.syncHeights());
            return;
          }

          const html = new DOMParser().parseFromString(text, 'text/html');
          const wrapper = html.querySelector('.swiper-wrapper');
          if (wrapper && wrapper.innerHTML.trim().length) {
            this.querySelector('.swiper-wrapper').innerHTML = wrapper.innerHTML;
            this.parent.classList.remove('hidden');
            this.initSlider();
          } else {
            this.releaseReservedSpace();
          }
        })
        .catch(e => {
          this.releaseReservedSpace();
          console.error(e);
        });
    }

    // 채워지기 전에 잡아둔 자리를 놓아준다. 받아올 상품이 없거나 받아오기가 실패하면
    // 슬라이더가 끝내 초기화되지 않으므로, 이 표시가 없으면 빈 자리가 그대로 남는다.
    releaseReservedSpace() {
      this.classList.add('card-product-slider--no-items');
    }

    initSlider(slider = this) {
      // 패치가 카드 초기화 전에 반드시 적용되도록 먼저 호출
      this.patchProductCardOnce();

      const rawOpts = JSON.parse(this.getAttribute('data-swiper-options') || '{}');

      // 브라우저 기본 가로 스크롤로 낼 수 있으면 Swiper 를 만들지 않는다.
      // 아래 담기 서랍·카드 초기화는 두 갈래 모두에서 그대로 돈다.
      const canUseNative = !!(window.NativeSlider && window.NativeSlider.usable(rawOpts));

      // 슬라이드가 아직 없던 첫 호출에서는 Swiper 가 먼저 만들어져 있을 수 있다.
      // 최근 본 상품이 그 모양이다 — 붙는 순간에는 비어 있고, 기록을 읽어 채운 뒤에
      // 다시 초기화한다. 남겨 두면 화면 폭이 바뀔 때 transform 을 다시 써서
      // 브라우저 스크롤과 싸우므로, 기본 스크롤로 가기 전에 걷어낸다.
      if (canUseNative && this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      // 장 폭은 Swiper 에 넘길 설정을 그대로 넘겨 같은 셈으로 낸다.
      this.nativeSlider = canUseNative
        ? window.NativeSlider.apply(slider, rawOpts, this.sliderOptions)
        : null;

      if (!this.nativeSlider) {
        this.slider = new Swiper(slider, this.sliderOptions);

        if (this.slider?.wrapperEl) {
          this.slider.wrapperEl.setAttribute('aria-live', 'polite');
          this.slider.wrapperEl.id = `swiper-wrapper-${this.dataset.sectionId || Math.random().toString(36).slice(2)}`;
        }

        (this.slider?.slides || []).forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `${i + 1} / ${this.slider.slides.length}`);
          slide.dataset.index = i;
        });

        const nav = this.slider?.navigation || {};
        const toArrayOfElements = (maybe) => {
          const out = [];
          const pushEl = (el) => { if (el && el.nodeType === 1) out.push(el); };
          if (!maybe) return out;
          if (Array.isArray(maybe)) { maybe.forEach(m => out.push(...toArrayOfElements(m))); return out; }
          if (maybe instanceof NodeList || maybe instanceof HTMLCollection) { out.push(...Array.from(maybe)); return out; }
          if (typeof maybe === 'string') { out.push(...Array.from(this.querySelectorAll(maybe))); return out; }
          pushEl(maybe);
          return out;
        };

        const navButtons = [...toArrayOfElements(nav.prevEl), ...toArrayOfElements(nav.nextEl)];
        navButtons.forEach((btn, i) => {
          const type = i < navButtons.length / 2 ? 'Previous' : 'Next';
          btn.setAttribute('aria-label', `${type} slide`);
          if (this.slider?.wrapperEl?.id) btn.setAttribute('aria-controls', this.slider.wrapperEl.id);
        });

        if (this.slider?.wrapperEl) {
          this.slider.wrapperEl.addEventListener('mouseenter', () => {
            if (this.slider?.autoplay && this.sliderOptions.autoplay) this.slider.autoplay.stop();
          });
          this.slider.wrapperEl.addEventListener('mouseleave', () => {
            if (!this.classList.contains('product--open-on-quick-cart') && this.slider?.autoplay && this.sliderOptions.autoplay) {
              if (rawOpts.autoplay !== false) this.slider.autoplay.start();
            }
            if (rawOpts.autoplay === false && this.slider?.autoplay) {
              this.slider.autoplay.stop();
            }
          });
        }
      }

      if (this.hasAttribute('data-init-quick-cart') &&
          document.querySelector('quick-cart-drawer') &&
          this.querySelector('.swiper-slide')) {
        document.querySelector('quick-cart-drawer').init();
      }

      // 카드들 초기화
      this.querySelectorAll('product-card').forEach(card => {
        try { card.init?.(); } catch(_) {}
      });

      if (window.Shopify && Shopify.designMode) {
        if (this.hasAttribute('data-init-quick-cart') &&
            document.querySelector('quick-cart-drawer') &&
            this.querySelector('.swiper-slide')) {
          document.querySelector('quick-cart-drawer').init();
        }
      }
    }

    patchProductCardOnce() {
      if (window.__patchedDiscountBadgeOnce__) return;

      const patchOne = (Ctor) => {
        if (!Ctor || !Ctor.prototype) return;
        if (Ctor.prototype.__patchedUpdateBadgeSafe) return;

        Ctor.prototype.updateDiscountBadgeForVariant = function (variantOrId) {
          // 1) variant resolve
          const v = (variantOrId && typeof variantOrId === 'object')
            ? variantOrId
            : (this.variantsObj || []).find(x => String(x.id) === String(variantOrId));
          if (!v) return;

          // 2) root resolve
          const root =
            this?.card ||
            this?.root ||
            (this.closest?.('.product-card') || this);

          // 3) 배지 컨테이너 찾기/생성
          let badge =
            root.querySelector?.('[data-discount-badge]') ||
            root.querySelector?.('.product-card__badge--discount') ||
            root.querySelector?.('.product-card__discount-badge');

          if (!badge) {
            // 배지를 전혀 안 그리는 카드면 조용히 반환 (크래시 방지)
            return;
          }

          // 4) 텍스트 노드 찾기/생성
          let rateEl =
            badge.querySelector('[data-rate]') ||
            badge.querySelector('[data-discount-rate]') ||
            badge.querySelector('.percentage');

          if (!rateEl) {
            rateEl = document.createElement('span');
            rateEl.className = 'percentage';
            badge.appendChild(rateEl);
          }

          // 5) 할인율 계산 및 표시/숨김
          const price = Number(v.price);
          const compare = Number(v.compare_at_price);
          const rate = (compare > price && compare > 0)
            ? Math.round(((compare - price) / compare) * 100)
            : 0;

          if (rate > 0) {
            rateEl.textContent = String(rate);
            badge.classList.remove('hidden');
            badge.removeAttribute?.('hidden');
          } else {
            rateEl.textContent = '';
            badge.classList.add('hidden');
            badge.setAttribute?.('hidden', '');
          }
        };

        Ctor.prototype.__patchedUpdateBadgeSafe = true;
      };

      // ProductCard, ProductCard2 모두 패치
      patchOne(window.ProductCard);
      patchOne(window.ProductCard2);

      window.__patchedDiscountBadgeOnce__ = true;
    }
  }

  customElements.define('card-product-slider', CardProductSlider);
}
